import { render, staticRenderFns } from "./r-ticket-dialog.vue?vue&type=template&id=0f2568aa&scoped=true"
import script from "./r-ticket-dialog.vue?vue&type=script&lang=js"
export * from "./r-ticket-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-ticket-dialog.vue?vue&type=style&index=0&id=0f2568aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2568aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2568aa')) {
      api.createRecord('0f2568aa', component.options)
    } else {
      api.reload('0f2568aa', component.options)
    }
    module.hot.accept("./r-ticket-dialog.vue?vue&type=template&id=0f2568aa&scoped=true", function () {
      api.rerender('0f2568aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-ticket-dialog.vue"
export default component.exports